// extracted by mini-css-extract-plugin
export default {"container":"NotificationSubscription_container__SapMM","icon":"NotificationSubscription_icon__cBRA2","content":"NotificationSubscription_content__82Psr"};